import CardsPage from '@/pages/CardsPage/CardsPage';

export default CardsPage;
